import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import {
  getUserRequests as getUserRequestsApi,
  acceptRejectUserRequest as acceptRejectUserRequestApi,
    getRequestDetail as getRequestDetailApi
 } from "../../helpers/custom_helper/backend_helper";


 export const getUserRequestThunk = createAsyncThunk("get-user-requests", async (contestData) => {
  try {

     const response = getUserRequestsApi(contestData);
     const data = await response;

    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});

export const acceptRejectUserRequestThunk = createAsyncThunk("accept-reject", async (postData) => {
  try {
   
     const response = acceptRejectUserRequestApi(postData);
     const data = await response;
    if(data.success)
    {
      return response;
    }else {
      toast.error(data.message)
        return response;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});



export const resetRequestThunk = createAsyncThunk( "resetContest",async () => {
    try {
      return true;
    } catch (error) {
      return error;
    }
  }
);

 export const getRequestDetailThunk = createAsyncThunk("get-request-details", async (requestId) => {
  try {
     const response = getRequestDetailApi(requestId);
     const data = await response;

    if(data.success)
    {
      return response;
    }else {
      toast.error(data.message)
        return response;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});






















